var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1615 21.5855L4.95484 14.3788C4.84564 14.2696 4.76812 14.1513 4.72226 14.0239C4.6764 13.8965 4.65383 13.76 4.65456 13.6145C4.65456 13.4689 4.67749 13.3324 4.72335 13.205C4.76921 13.0776 4.84637 12.9593 4.95484 12.8501L12.1615 5.64342C12.3617 5.44323 12.6121 5.33877 12.9128 5.33003C13.2134 5.3213 13.4726 5.42576 13.6902 5.64342C13.9086 5.8436 14.0225 6.09402 14.032 6.39466C14.0415 6.6953 13.9366 6.95445 13.7175 7.17211L8.3671 12.5225H20.5693C20.8787 12.5225 21.1382 12.6274 21.3479 12.837C21.5575 13.0467 21.662 13.3058 21.6613 13.6145C21.6613 13.9238 21.5568 14.1834 21.3479 14.393C21.139 14.6027 20.8795 14.7071 20.5693 14.7064H8.3671L13.7175 20.0568C13.9177 20.257 14.0225 20.5118 14.032 20.8212C14.0415 21.1305 13.9366 21.3853 13.7175 21.5855C13.5173 21.8039 13.2626 21.9131 12.9532 21.9131C12.6438 21.9131 12.3799 21.8039 12.1615 21.5855Z",
    fill: "#FDF7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.6fd8b2b78726fd3fe9b5eb2cea7d018b.svg";
export { ForwardRef as ReactComponent };